import { Injectable } from '@angular/core';
import { IconWeight } from '@nimbus-library/features/shared/directives/icon-weight.enum';
import { IconParametersService } from '@nimbus-library/features/shared/services/icon-parameters.service';

@Injectable()
export class DefaultIconParametersService extends IconParametersService {
  public getIconParameters(iconName: string, iconWeight: IconWeight) {
    const parameters = super.getIconParameters(iconName, iconWeight);

    if (!parameters) {
      throw new Error('Cannot find the requested icon in the store.');
    }

    return parameters;
  }
}
